<template>
  <div ref="chartRef" :style="{ width: width, height: height }"></div>
</template>

<script>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
import * as echarts from 'echarts';

export default {
  name: 'BarChart',
  props: {
    title: {
      type: String,
      default: '柱狀圖'
    },
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    xAxisKey: {
      type: String,
      default: 'name'
    },
    yAxisKey: {
      type: String,
      default: 'value'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    color: {
      type: String,
      default: '#4facfe'
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const chartRef = ref(null);
    let chartInstance = null;

    const initChart = () => {
      if (!chartRef.value) return;

      chartInstance = echarts.init(chartRef.value);

      const xAxisData = props.data.map(item => item[props.xAxisKey]);
      const seriesData = props.data.map(item => item[props.yAxisKey]);

      const option = {
        title: {
          text: props.title,
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 500,
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: props.horizontal ? 'value' : 'category',
          data: props.horizontal ? undefined : xAxisData,
          axisLabel: {
            rotate: props.horizontal ? 0 : 45,
            interval: 'auto'
          }
        },
        yAxis: {
          type: props.horizontal ? 'category' : 'value',
          data: props.horizontal ? xAxisData : undefined
        },
        series: [
          {
            name: props.title,
            type: 'bar',
            data: seriesData,
            itemStyle: {
              color: props.color
            },
            label: {
              show: true,
              position: props.horizontal ? 'right' : 'top'
            }
          }
        ]
      };

      chartInstance.setOption(option);
    };

    const updateChart = () => {
      if (!chartInstance) return;

      const xAxisData = props.data.map(item => item[props.xAxisKey]);
      const seriesData = props.data.map(item => item[props.yAxisKey]);

      chartInstance.setOption({
        xAxis: {
          data: props.horizontal ? undefined : xAxisData
        },
        yAxis: {
          data: props.horizontal ? xAxisData : undefined
        },
        series: [
          {
            data: seriesData
          }
        ]
      });
    };

    onMounted(() => {
      initChart();
    });

    watch(() => props.data, () => {
      updateChart();
    }, { deep: true });

    onBeforeUnmount(() => {
      if (chartInstance) {
        chartInstance.dispose();
      }
    });

    return {
      chartRef
    };
  }
};
</script>
